// Status das notas fiscais gravados pelo servidor (status da Spedy em maiúsculas + status internos)
// color: cor do Chip do MUI
const STATUS_NOTA = {
    PENDENTE: { label: 'Processando', color: 'warning' },
    AUTHORIZED: { label: 'Emitida', color: 'success' },
    REJECTED: { label: 'Rejeitada', color: 'error' },
    DENIED: { label: 'Denegada', color: 'error' },
    ERRO: { label: 'Erro no envio', color: 'error' },
    'CANCELAMENTO EM ANDAMENTO': { label: 'Cancelando', color: 'warning' },
    CANCELED: { label: 'Cancelada', color: 'default' },
    REMOVED: { label: 'Removida', color: 'default' },
    DISABLED: { label: 'Inutilizada', color: 'default' },
};

export const statusNota = (status) => STATUS_NOTA[status] || { label: status || '—', color: 'default' };

// PDF existe a partir da autorização (inclusive notas canceladas)
export const podeBaixarPdf = (status) => ['AUTHORIZED', 'CANCELAMENTO EM ANDAMENTO', 'CANCELED'].includes(status);

export const podeCancelar = (status) => status === 'AUTHORIZED';

// dadosNFSe pode chegar como objeto ou como string JSON (registros antigos)
export const dadosNota = (nota) => {
    let dados = nota?.dadosNFSe;
    while (typeof dados === 'string') {
        try {
            dados = JSON.parse(dados);
        } catch {
            return {};
        }
    }
    if (!dados || typeof dados !== 'object') return {};
    return dados.event && dados.data ? dados.data : dados;
};

export const tomadorNota = (nota) => dadosNota(nota).receiver?.name || '';

export const numeroNota = (nota) => nota?.numeroNota || dadosNota(nota).number || '';

// Motivo informado pela prefeitura/Spedy quando a nota é rejeitada
export const mensagemNota = (nota) => nota?.mensagemErro || dadosNota(nota).processingDetail?.message || '';
